import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// LangDirSync — keeps the top-level <html lang="…" dir="…">
// attributes in sync with the currently active route so that browsers,
// screen readers and SEO crawlers see the correct language and text
// direction for every Arabic (/ar/…) and English page.
//
// Rules:
//   • Any path that starts with `/ar` (including `/ar`, `/ar/…`) →
//     lang="ar", dir="rtl".
//   • Everything else → lang="en", dir="ltr".
//
// This component renders nothing. Mount it once inside <BrowserRouter>.
export default function LangDirSync() {
    const { pathname } = useLocation();

    useEffect(() => {
        const isAr = pathname === "/ar" || pathname.startsWith("/ar/");
        const html = document.documentElement;
        html.setAttribute("lang", isAr ? "ar" : "en");
        html.setAttribute("dir", isAr ? "rtl" : "ltr");
    }, [pathname]);

    return null;
}
